interface ISortOrderTypes {
  asc: string;
  desc: string;
}

export const SortOrderTypes: ISortOrderTypes = {
  asc: "asc",
  desc: "desc",
};
